import * as copy from 'src/common/templates/copy';

export const GLOBAL_SYMBOL = '*';
export const GLOBAL_DISPLAY_NAME = `All Databases`;
export const globalSymbolToName = (s: string) =>
  s === GLOBAL_SYMBOL ? GLOBAL_DISPLAY_NAME : s;
export const globalDisplayNameToSymbol = (s: string) =>
  s === GLOBAL_DISPLAY_NAME ? GLOBAL_SYMBOL : s;

export const SCOPE_TOOLTIP_MSG = `A query stored to a specific database can only be programmatically executed against that database.`;

export const abbreviate = (s: string, n = 0) =>
  s.length > n ? s.substr(0, n).concat('...') : s;

export const VOICEBOX_QUERY_PROMPT_TAG =
  copy.components.workspace.storedQueryPopover.voiceboxTags.prompt;
export const VOICEBOX_EXAMPLE_QUERY_TAG =
  copy.components.workspace.storedQueryPopover.voiceboxTags.example;

// Used for normalizing case when special tags are entered manually
export const SPECIAL_TAGS_BY_LOWERCASE = Object.fromEntries(
  [VOICEBOX_QUERY_PROMPT_TAG, VOICEBOX_EXAMPLE_QUERY_TAG].map((tag) => [
    tag.toLowerCase(),
    tag,
  ])
);

export const RESERVED_QUERY_TAGS = new Set([VOICEBOX_EXAMPLE_QUERY_TAG]);
